import PolingListener from "@/libs/counter/PolingListener";
import LoggedInListener from "@/libs/counter/LoggedInListener";
import {UserApi} from "@core/api";

export function createCounterListener(dataProcessor) {
    const listener = new PolingListener(
        () => UserApi.getCounters(),
        dataProcessor
    );

    return new LoggedInListener(listener);
}
